import { Routes, } from '@angular/router';
import { MessagesListWrapperComponent } from './messages-list-wrapper.component';

export const MessagesRoutes: Routes = [
	{ path: '', component: MessagesListWrapperComponent },
	{ path: ':id', component: MessagesListWrapperComponent }
];
